export const EntityType = {
    Dealer: "dealer",
    Transporter: "transporter",
};
export var PricingStrategyType;
(function (PricingStrategyType) {
    PricingStrategyType[PricingStrategyType["ShipperFixed"] = 1] = "ShipperFixed";
    PricingStrategyType[PricingStrategyType["ShipperCostPlus"] = 2] = "ShipperCostPlus";
    PricingStrategyType[PricingStrategyType["ShipperVariable"] = 3] = "ShipperVariable";
    PricingStrategyType[PricingStrategyType["ShipperPricingBand"] = 4] = "ShipperPricingBand";
    PricingStrategyType[PricingStrategyType["ShipperNissanCityToCity"] = 5] = "ShipperNissanCityToCity";
    PricingStrategyType[PricingStrategyType["ShipperResidential"] = 6] = "ShipperResidential";
    PricingStrategyType[PricingStrategyType["TransporterVariable"] = 7] = "TransporterVariable";
    PricingStrategyType[PricingStrategyType["TransporterNissanCityToCity"] = 8] = "TransporterNissanCityToCity";
    PricingStrategyType[PricingStrategyType["ShipperBracketedMileage"] = 9] = "ShipperBracketedMileage";
    PricingStrategyType[PricingStrategyType["ShipperHistorical"] = 10] = "ShipperHistorical";
    PricingStrategyType[PricingStrategyType["TransporterHistorical"] = 11] = "TransporterHistorical";
})(PricingStrategyType || (PricingStrategyType = {}));
export const dealerStrategiesNames = {
    [PricingStrategyType.ShipperVariable]: "Variable",
    [PricingStrategyType.ShipperFixed]: "Fixed by Zip",
    [PricingStrategyType.ShipperPricingBand]: "Pricing Bands",
    [PricingStrategyType.ShipperCostPlus]: "Cost plus",
    [PricingStrategyType.ShipperNissanCityToCity]: "Nissan City to City",
    [PricingStrategyType.ShipperResidential]: "Residential",
    [PricingStrategyType.ShipperBracketedMileage]: "Bracketed Mileage",
    [PricingStrategyType.ShipperHistorical]: "Historical",
};
export const dealerStrategiesOptions = Object.entries(dealerStrategiesNames)
    .map(([value, label]) => ({
    value: Number.parseInt(value, 10),
    label,
}))
    .filter(strategy => strategy.value !== PricingStrategyType.ShipperNissanCityToCity);
export const transporterStrategiesNames = {
    [PricingStrategyType.TransporterVariable]: "Variable",
    [PricingStrategyType.TransporterNissanCityToCity]: "Nissan City to City",
    [PricingStrategyType.TransporterHistorical]: "Historical",
};
export const transporterStrategiesOptions = Object.entries(transporterStrategiesNames)
    .map(([value, label]) => ({
    value: Number.parseInt(value, 10),
    label,
}))
    .filter(strategy => strategy.value !== PricingStrategyType.TransporterNissanCityToCity);
const emptyStrategy = {
    concurrencyStamp: null,
    id: null,
    referenceId: null,
};
export const emptyDealerStrategies = {
    [PricingStrategyType.ShipperVariable]: {
        ...emptyStrategy,
        strategyType: PricingStrategyType.ShipperVariable,
        margin: 10,
    },
    [PricingStrategyType.ShipperPricingBand]: {
        ...emptyStrategy,
        strategyType: PricingStrategyType.ShipperPricingBand,
    },
    [PricingStrategyType.ShipperFixed]: {
        ...emptyStrategy,
        strategyType: PricingStrategyType.ShipperFixed,
        items: [],
        totalCount: 0,
    },
    [PricingStrategyType.ShipperCostPlus]: {
        ...emptyStrategy,
        strategyType: PricingStrategyType.ShipperCostPlus,
        amount: 100,
    },
    [PricingStrategyType.ShipperNissanCityToCity]: {
        ...emptyStrategy,
        strategyType: PricingStrategyType.ShipperNissanCityToCity,
    },
    [PricingStrategyType.ShipperResidential]: {
        ...emptyStrategy,
        strategyType: PricingStrategyType.ShipperResidential,
    },
    [PricingStrategyType.ShipperHistorical]: {
        ...emptyStrategy,
        strategyType: PricingStrategyType.ShipperHistorical,
    },
};
export const emptyTransporterStrategies = {
    [PricingStrategyType.TransporterVariable]: {
        ...emptyStrategy,
        strategyType: PricingStrategyType.TransporterVariable,
    },
    [PricingStrategyType.TransporterNissanCityToCity]: {
        ...emptyStrategy,
        strategyType: PricingStrategyType.TransporterNissanCityToCity,
    },
    [PricingStrategyType.TransporterHistorical]: {
        ...emptyStrategy,
        strategyType: PricingStrategyType.TransporterHistorical,
    },
};
export const fetchDealerStrategyByType = {
    [PricingStrategyType.ShipperVariable]: "pricingStrategies/dealerGetStrategyVariable",
    [PricingStrategyType.ShipperPricingBand]: "pricingStrategies/dealerGetStrategyPricingBands",
    [PricingStrategyType.ShipperFixed]: "pricingStrategies/dealerGetStrategyFixedByZip",
    [PricingStrategyType.ShipperCostPlus]: "pricingStrategies/dealerGetStrategyCostPlus",
    [PricingStrategyType.ShipperNissanCityToCity]: "pricingStrategies/dealerGetStrategyNissanCityToCity",
    [PricingStrategyType.ShipperResidential]: "pricingStrategies/dealerGetStrategyResidential",
    [PricingStrategyType.ShipperBracketedMileage]: "pricingStrategies/dealerGetStrategyBracketedMileage",
    [PricingStrategyType.ShipperHistorical]: "pricingStrategies/dealerGetStrategyHistorical",
};
export const fetchTransporterStrategyByType = {
    [PricingStrategyType.TransporterVariable]: "pricingStrategies/transporterGetVariable",
    [PricingStrategyType.TransporterNissanCityToCity]: "pricingStrategies/transporterGetStrategyNissanCityToCity",
    [PricingStrategyType.TransporterHistorical]: "pricingStrategies/transporterGetStrategyHistorical",
    [PricingStrategyType.ShipperVariable]: "pricingStrategies/transporterGetStrategyVariable",
};
export const dealerStrategyInitialParamsByType = {
    [PricingStrategyType.ShipperFixed]: {
        page: 1,
        pageSize: 10,
    },
    [PricingStrategyType.ShipperPricingBand]: {
        page: 1,
        pageSize: 10,
    },
    [PricingStrategyType.ShipperBracketedMileage]: {
        page: 1,
        pageSize: 10,
    },
};
export const transporterStrategyInitialParamsByType = {
    [PricingStrategyType.TransporterVariable]: {
        page: 1,
        pageSize: 10,
    },
};
export var PricingValueTypeEnum;
(function (PricingValueTypeEnum) {
    PricingValueTypeEnum[PricingValueTypeEnum["Default"] = 1] = "Default";
    PricingValueTypeEnum[PricingValueTypeEnum["Group"] = 2] = "Group";
    PricingValueTypeEnum[PricingValueTypeEnum["Dealer"] = 3] = "Dealer";
})(PricingValueTypeEnum || (PricingValueTypeEnum = {}));
export var FixedZipDirection;
(function (FixedZipDirection) {
    FixedZipDirection[FixedZipDirection["OneWay"] = 1] = "OneWay";
    FixedZipDirection[FixedZipDirection["Both"] = 2] = "Both";
})(FixedZipDirection || (FixedZipDirection = {}));
export var PricingProcedure;
(function (PricingProcedure) {
    PricingProcedure[PricingProcedure["Custom"] = 1] = "Custom";
    PricingProcedure[PricingProcedure["Individual"] = 2] = "Individual";
    PricingProcedure[PricingProcedure["Nissan"] = 3] = "Nissan";
})(PricingProcedure || (PricingProcedure = {}));
export const PricingProcedureNames = {
    [PricingProcedure.Custom]: "Custom",
    [PricingProcedure.Individual]: "Individual",
    [PricingProcedure.Nissan]: "Nissan",
};
export const specialProceduresParser = {
    [PricingProcedure.Custom]: {
        dealer: {
            dispatchType: "pricingStrategies/dealerGetStrategyFixedByZip",
            strategyType: PricingStrategyType.ShipperFixed,
        },
        transporter: {
            dispatchType: "pricingStrategies/transporterGetStrategyVariable",
            strategyType: PricingStrategyType.ShipperVariable,
        },
    },
    [PricingProcedure.Nissan]: {
        dealer: {
            dispatchType: "pricingStrategies/dealerGetStrategyNissanCityToCity",
            strategyType: PricingStrategyType.ShipperNissanCityToCity,
        },
        transporter: {
            dispatchType: "pricingStrategies/transporterGetStrategyNissanCityToCity",
            strategyType: PricingStrategyType.TransporterNissanCityToCity,
        },
    },
};
export const VehicleBreakpoints = {
    Car1: "Car1",
    SUV1: "SUV1",
    Truck1: "Truck1",
    Truck2: "Truck2",
};
export const VehicleBreakpointColumns = Object.values(VehicleBreakpoints);
export const VehicleBreakpointNames = {
    [VehicleBreakpoints.Car1]: "Car",
    [VehicleBreakpoints.SUV1]: "SUV",
    [VehicleBreakpoints.Truck1]: "Truck",
    [VehicleBreakpoints.Truck2]: "Heavy Truck",
};
